import DraggableContainer from '@/shared/Activities/GameActivity/ClassicGameActivity/DragAndMatchActivity/DragAndMatchGame/GameLoop/DraggableContainer/DraggableContainer';
import { StyledDragPage } from './DragPage.styled';
import DraggableImage from './DraggableImage/DraggableImage';
import DroppableText from './DroppableText/DroppableText';
import useDragPage from './useDragPage.hook';
import DraggableContent from '../../components/DraggableContent/DraggableContent';
import { DragOverlay, rectIntersection } from '@dnd-kit/core';
import AudioPlayPauseButton from '../../components/AudioPlayPauseButton/AudioPlayPauseButton';
import AnswerFeedback from '../../components/AnswerFeedback/AnswerFeedback';

export default function DragPage({ page, folder, activityActions }) {
  const cloudFolder = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${folder}`;

  const { state, actions } = useDragPage({
    page,
    cloudFolder,
    activityActions,
  });

  const images = state.images.map((image) => ({
    ...image,
    invisible: state.answers.find((answer) => answer.id == image.id),
  }));

  console.log('answered', state.answered);
  return (
    <StyledDragPage imgCount={state.images?.length ?? 5}>
      <div className="title">{page.data.text}</div>
      <div className="draggable-container">
        <DraggableContainer
          onDragStart={actions.onDragStart}
          onDragEnd={actions.onDragEnd}
          collisionDetection={rectIntersection}
        >
          <div className="texts-and-gaps">
            <div className="texts">
              {state.texts.map((text, index) => {
                const audio = text.audio || `audios/${page.id}-${text.id}.mp3`;
                const audioSrc = `${cloudFolder}/${audio}`;
                return (
                  <div className="text-with-audio" key={index}>
                    <div className="text">
                      {text.text}
                      <span className="audio-button">
                        <AudioPlayPauseButton
                          size="small"
                          src={audioSrc}
                          className="audio-player"
                        />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="text-with-gaps">
              {state.texts.map((text, index) => {
                const answer = state.answers.find(
                  (answer) => answer.answerId == text.id
                );
                const image = answer
                  ? state.images.find((image) => image.id == answer.id)
                  : null;
                const correctImage = state.images.find(
                  (image) => image.id == text.id
                );
                const isAnswerCorrect = answer?.id == correctImage.id;
                return (
                  <div key={index} className="gap-wrapper">
                    <DroppableText id={text.id}>
                      <div className="gap">
                        {answer ? (
                          <>
                            <DraggableImage
                              id={answer.id}
                              text={image.text}
                              imgSrc={image.imgSrc}
                              audioFile={`${page.id}-${image.id}.mp3`}
                              disabled={state.answered}
                            >
                              <DraggableContent
                                className="dropped"
                                style={{
                                  visibility:
                                    image.id == state.draggedOptionId
                                      ? 'hidden'
                                      : 'visible',
                                }}
                                id={image.id}
                              >
                                <img
                                  src={image.imgSrc}
                                  alt=""
                                  className={`${
                                    state.answered && !isAnswerCorrect
                                      ? 'incorrect-image'
                                      : ''
                                  }`}
                                />
                              </DraggableContent>
                              <AnswerFeedback
                                className="feedback"
                                allAnswered={state.answered}
                                allCorrect={state.correct}
                                correct={isAnswerCorrect}
                              />
                            </DraggableImage>
                            {state.answered && !isAnswerCorrect && (
                              <div className="correct-answer">
                                <span className="info">
                                  The correct answer is:
                                </span>
                                <div className="image-container">
                                  <img src={correctImage.imgSrc} alt="" />
                                </div>
                              </div>
                            )}
                          </>
                        ) : null}
                      </div>
                    </DroppableText>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="images">
            {images.map((image) => {
              return image.invisible ? (
                <div className="option-wrapper invisible" key={image.id}></div>
              ) : (
                <div className="option-wrapper" key={image.id}>
                  <DraggableImage
                    id={image.id}
                    text={image.text}
                    imgSrc={image.imgSrc}
                    audioFile={`${page.id}-${image.id}.mp3`}
                  >
                    <DraggableContent
                      style={{
                        visibility:
                          image.id == state.draggedOptionId
                            ? 'hidden'
                            : 'visible',
                      }}
                      id={image.id}
                      rndYSign={false}
                      yLimits={{ min: 10, max: 30 }}
                    >
                      <img src={image.imgSrc} alt="" />
                    </DraggableContent>
                  </DraggableImage>
                </div>
              );
            })}
          </div>
          <DragOverlay>
            {state.draggedOptionId ? (
              <DraggableContent className="dragged" id={state.draggedOptionId}>
                <img
                  src={
                    state.images.find(
                      (image) => image.id == state.draggedOptionId
                    ).imgSrc
                  }
                  alt=""
                />
              </DraggableContent>
            ) : null}
          </DragOverlay>
        </DraggableContainer>
      </div>
    </StyledDragPage>
  );
}
